import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 列表
  getLogsList: params => request({
    url: `${requestUrl}/log/page`,
    method: "get",
    params
  })
};

export default api;
